import { render } from "./Index.vue?vue&type=template&id=f47b93d6&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=f47b93d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f47b93d6"

export default script